import React, {useState, useEffect, useRef} from 'react';
import {findTablePendingSale} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";

const TablePendingSaleList = () => {
    const [tables, setTables] = useState([]);
    const [filteredTables, setFilteredTables] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const result = await findTablePendingSale(query);
            setTables(result || []);
            setFilteredTables(result || []);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []);

    function removeSpecialChars(str) {
        return str.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
    }

    useEffect(() => {
        const filtered = tables.filter((f) => removeSpecialChars(f.name).toUpperCase().includes(queryString));
        setFilteredTables(filtered);
    }, [queryString, tables]);

    const handleInputChange = (e) => {
        setQueryString(removeSpecialChars(e.target.value).toUpperCase());
    };

    return (
        <>
            <div className="header-label">Fechar Mesa</div>

            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                className="input-container">
                <input style={{width: '100%'}} ref={inputQueryString} type="text" value={queryString}
                       onChange={handleInputChange} onFocus={(event) => event.target.select()} inputMode="numeric"/>
                <button id="clearButton" onClick={() => {
                    setQueryString('');
                    inputQueryString.current.focus();
                }}>X
                </button>
            </div>
            <div style={{flexGrow: 1, overflowY: "auto"}}>
                <table style={{width: '100%'}}>
                    <colgroup>
                        <col style={{width: '300px'}}/>
                        <col style={{width: '50px'}}/>
                    </colgroup>
                    <tbody style={{overflowY: 'auto'}}>
                    {filteredTables.map((table, index) => (
                        <tr key={index}>
                            <td>
                                <div key={index}>{table.name}</div>
                            </td>
                            <td>
                                <button onClick={() => {
                                    navigate('/sale/finishtable/' + table.id);
                                }}>Conferir
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                    {filteredTables.length === 0 &&
                        <tfoot>
                        <tr>
                            <td colSpan={2}>
                                Nenhuma mesa com pedido pendente
                            </td>
                        </tr>
                        </tfoot>
                    }
                </table>
            </div>
        </>
    );
};

export default TablePendingSaleList;
